export default __webpack_public_path__ + "static/media/linkedin.934aa885.svg";